import * as globals from "./globals";
import type { OctopusTheme } from "./OctopusTheme";
export const lightTheme: OctopusTheme = {
    
};